import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import UserSidebar from "../../Component/UserSidebar";
import FormDiagnostics from "./form";
import PropTypes from "prop-types";
import { getSubdomainPath } from "../../utils/helpers";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const Index = (props) => {
  const { title } = props;
  const subDomainPath = getSubdomainPath();

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading">
            {(subDomainPath === "siddev" || subDomainPath === "siduat" || subDomainPath === "sid") ? "Self Assessment Tool" : "Goal Setting"}
          </h1>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            <FormDiagnostics />
          </div>
        </div>
      </div>
    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Index;
